import {
  FETCH_PRODUCTS_BY_CATEGORY_PENDING,
  FETCH_PRODUCTS_BY_CATEGORY_FULFILLED,
  FETCH_PRODUCTS_BY_CATEGORY_REJECTED,
  FETCH_PRODUCT_BY_SLUG_PENDING,
  FETCH_PRODUCT_BY_SLUG_FULFILLED,
  FETCH_PRODUCT_BY_SLUG_REJECTED,
  SET_PRODUCT,
  FEATURED_PRODUCTS_PENDING,
  FEATURED_PRODUCTS_FULFILLED,
  FEATURED_PRODUCTS_REJECTED,
  RECENTLY_ADDED_PRODUCTS_PENDING,
  RECENTLY_ADDED_PRODUCTS_FULFILLED,
  RECENTLY_ADDED_PRODUCTS_REJECTED,
  OTHER_PRODUCTS_PENDING,
  OTHER_PRODUCTS_FULFILLED,
  OTHER_PRODUCTS_REJECTED,
  SEARCH_PRODUCTS_BY_CATEGORY_PENDING,
  SEARCH_PRODUCTS_BY_CATEGORY_FULFILLED,
  SEARCH_PRODUCTS_BY_CATEGORY_REJECTED,
} from "../actions/product";

const initialState = {
  fetching: false,
  products: [],
  product: null,
  featuredProducts: [],
  featuredFetching: false,

  recentlyAddedProducts: [],
  recentlyAddedFetching: false,

  otherProducts: [],
  otherFetching: false,

  searchProductsFetching: false,
  searchProducts: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case OTHER_PRODUCTS_PENDING:
      return {
        ...state,
        otherFetching: true,
      };
    case OTHER_PRODUCTS_FULFILLED:
      return {
        ...state,
        otherProducts: action.payload,
        otherFetching: false,
      };
    case OTHER_PRODUCTS_REJECTED:
      return {
        ...state,
        otherFetching: false,
      };

    case RECENTLY_ADDED_PRODUCTS_PENDING:
      return {
        ...state,
        recentlyAddedFetching: true,
      };
    case RECENTLY_ADDED_PRODUCTS_FULFILLED:
      return {
        ...state,
        recentlyAddedProducts: action.payload,
        recentlyAddedFetching: false,
      };
    case RECENTLY_ADDED_PRODUCTS_REJECTED:
      return {
        ...state,
        recentlyAddedFetching: false,
      };

    case FEATURED_PRODUCTS_PENDING:
      return {
        ...state,
        featuredFetching: true,
      };
    case FEATURED_PRODUCTS_FULFILLED:
      return {
        ...state,
        featuredProducts: action.payload,
        featuredFetching: false,
      };
    case FEATURED_PRODUCTS_REJECTED:
      return {
        ...state,
        featuredFetching: false,
      };

    case FETCH_PRODUCT_BY_SLUG_PENDING:
      return {
        ...state,
        product: null,
        fetching: true,
      };
    case FETCH_PRODUCT_BY_SLUG_FULFILLED:
      return {
        ...state,
        product: action.payload,
        fetching: false,
      };
    case FETCH_PRODUCT_BY_SLUG_REJECTED:
      return {
        ...state,
        fetching: false,
      };

    case FETCH_PRODUCTS_BY_CATEGORY_PENDING:
      return {
        ...state,
        fetching: true,
      };
    case FETCH_PRODUCTS_BY_CATEGORY_FULFILLED:
      return {
        ...state,
        products: action.payload,
        fetching: false,
      };
    case FETCH_PRODUCTS_BY_CATEGORY_REJECTED:
      return {
        ...state,
        fetching: false,
      };

    case SEARCH_PRODUCTS_BY_CATEGORY_PENDING:
      return {
        ...state,
        searchProductsFetching: true,
      };
    case SEARCH_PRODUCTS_BY_CATEGORY_FULFILLED:
      return {
        ...state,
        searchProducts: action.payload,
        searchProductsFetching: false,
      };
    case SEARCH_PRODUCTS_BY_CATEGORY_REJECTED:
      return {
        ...state,
        searchProductsFetching: false,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/productReducer.js